import React from 'react';
import { Table, Select } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { FuelReceipt } from '../../types';

const { Option } = Select;

export const FuelReceiptDraftsTab: React.FC<{
  t: (key: string) => string;
  isMobile: boolean;
  draftReceipts: FuelReceipt[];
  draftLinkFilter: 'all' | 'linked' | 'unlinked';
  onFilterChange: (value: 'all' | 'linked' | 'unlinked') => void;
  mobileColumns: ColumnsType<FuelReceipt>;
  desktopColumns: ColumnsType<FuelReceipt>;
  loading: boolean;
}> = ({
  t,
  isMobile,
  draftReceipts,
  draftLinkFilter,
  onFilterChange,
  mobileColumns,
  desktopColumns,
  loading
}) => (
  <div>
    <div style={{ marginBottom: '12px' }}>
      <Select
        value={draftLinkFilter}
        onChange={onFilterChange}
        style={{ width: isMobile ? '100%' : 200 }}
        size={isMobile ? 'middle' : 'middle'}
      >
        <Option value="all">{t('all.records')}</Option>
        <Option value="linked">{t('linked.records')}</Option>
        <Option value="unlinked">{t('unlinked.records')}</Option>
      </Select>
    </div>
    <Table
      columns={isMobile ? mobileColumns : desktopColumns}
      dataSource={draftReceipts.filter(receipt => {
        if (draftLinkFilter === 'linked') return !!receipt.shippingRecordId;
        if (draftLinkFilter === 'unlinked') return !receipt.shippingRecordId;
        return true;
      })}
      rowKey="id"
      loading={loading}
      pagination={{ pageSize: isMobile ? 5 : 10, simple: isMobile }}
      scroll={{ x: isMobile ? 350 : 1500 }}
      size={isMobile ? 'small' : 'middle'}
    />
  </div>
);

export const FuelReceiptCreatedTab: React.FC<{
  t: (key: string) => string;
  isMobile: boolean;
  createdReceipts: FuelReceipt[];
  createdLinkFilter: 'all' | 'linked' | 'unlinked';
  onFilterChange: (value: 'all' | 'linked' | 'unlinked') => void;
  mobileColumns: ColumnsType<FuelReceipt>;
  desktopColumns: ColumnsType<FuelReceipt>;
  loading: boolean;
}> = ({
  t,
  isMobile,
  createdReceipts,
  createdLinkFilter,
  onFilterChange,
  mobileColumns,
  desktopColumns,
  loading
}) => (
  <div>
    <div style={{ marginBottom: '12px' }}>
      <Select
        value={createdLinkFilter}
        onChange={onFilterChange}
        style={{ width: isMobile ? '100%' : 200 }}
        size={isMobile ? 'middle' : 'middle'}
      >
        <Option value="all">{t('all.records')}</Option>
        <Option value="linked">{t('linked.records')}</Option>
        <Option value="unlinked">{t('unlinked.records')}</Option>
      </Select>
    </div>
    <Table
      columns={isMobile ? mobileColumns : desktopColumns}
      dataSource={createdReceipts.filter(receipt => {
        if (createdLinkFilter === 'linked') return !!receipt.shippingRecordId;
        if (createdLinkFilter === 'unlinked') return !receipt.shippingRecordId;
        return true;
      })}
      rowKey="id"
      loading={loading}
      pagination={{ pageSize: isMobile ? 5 : 10, simple: isMobile }}
      scroll={{ x: isMobile ? 350 : 1500 }}
      size={isMobile ? 'small' : 'middle'}
    />
  </div>
);
